import { Skeleton } from '@/components/ui';

/**
 * Placeholder rows for the inbox list while items are loading. Mirrors
 * the shape of `InboxRow` (left checkbox slot, chevron + icon, title +
 * preview, right timestamp) so the layout doesn't reflow once data
 * arrives.
 */
export function InboxListSkeleton({ rows = 6 }: { rows?: number }) {
  return (
    <ul
      className="overflow-hidden rounded-lg border border-border bg-card"
      aria-hidden
    >
      {Array.from({ length: rows }).map((_, i) => (
        <li
          key={i}
          className="flex w-full items-start border-b border-l-2 border-l-transparent border-border last:border-b-0"
        >
          {/* Checkbox slot — matches InboxRow's pl-3 pr-1 pt-3.5 wrapper */}
          <div className="flex shrink-0 items-start pl-3 pr-1 pt-3.5">
            <Skeleton className="h-3.5 w-3.5 rounded" />
          </div>
          {/* Body — chevron, icon, title block, timestamp */}
          <div className="flex flex-1 items-start gap-3 py-3 pl-2 pr-2">
            <Skeleton className="mt-1 h-3.5 w-3.5 shrink-0 rounded" />
            <Skeleton className="mt-0.5 h-4 w-4 shrink-0 rounded" />
            <div className="min-w-0 flex-1 space-y-1.5">
              <Skeleton className="h-3.5 w-[28%] rounded" />
              <Skeleton className="h-3.5 w-[90%] rounded" />
            </div>
            <Skeleton className="mt-0.5 h-3 w-14 shrink-0 rounded" />
          </div>
          {/* Reserved menu inset — invisible at rest, same as the live row */}
          <div className="shrink-0 pl-1 pr-2 pt-3" aria-hidden>
            <div className="h-5 w-5" />
          </div>
        </li>
      ))}
    </ul>
  );
}
